/* HVAC-064-AB */
(function () {
  function redirectToGoodmanVendorFilter() {
    const url = new URL(window.location.href);
    url.searchParams.delete('wizard');
    url.searchParams.delete('goodman');
    url.searchParams.delete('filter.p.vendor');
    url.searchParams.append('filter.p.vendor', 'Goodman');
    const query = url.searchParams.toString();
    window.location.replace(`${url.pathname}${query ? `?${query}` : ''}${url.hash}`);
  }

  function maybeFallbackGoodmanVendorFilter() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('wizard') !== 'open') return;
    if (params.get('goodman') !== '1' && params.get('goodman') !== 'true') return;
    if (document.getElementById('collection-filter-wizard')) return;
    redirectToGoodmanVendorFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeFallbackGoodmanVendorFilter);
  } else {
    maybeFallbackGoodmanVendorFilter();
  }
})();
